import { Banner, stenaHazardous } from "@stenajs-webui/elements";

import { resolveInformationMessageBannerVariant } from "../../../../common-ui/information-message/informationMessageUtils";
import { FlatButtonLink } from "../../../../common-ui/Link";
import { routeCreators } from "../../../../common/routes/AppRoutes";
import type { ApprovalConfig } from "../../../../common/utils/approvalInfo";

interface BookingHazardousGoodsBannerProps {
  approvalInfo: ApprovalConfig;
  bookingNo: number;
  hazardousGoodsApproved: boolean;
}

export function BookingHazardousGoodsBanner({
  bookingNo,
  hazardousGoodsApproved,
  approvalInfo,
}: BookingHazardousGoodsBannerProps) {
  return (
    <Banner
      icon={stenaHazardous}
      variant={resolveInformationMessageBannerVariant(approvalInfo.type)}
      text={approvalInfo.descriptionText}
      contentRight={
        hazardousGoodsApproved && (
          <FlatButtonLink
            to={routeCreators.hazardousGoods({ bookingNo })}
            label={"See details"}
          />
        )
      }
    />
  );
}
